var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_48434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0931 21.2792C18.8256 19.1547 17.7875 17.2021 16.1761 15.792C14.5645 14.382 12.4916 13.6124 10.3503 13.6292C8.20901 13.6124 6.13605 14.382 4.52453 15.792C2.91301 17.2021 1.87502 19.1547 1.60742 21.2792",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3505 11.4431C13.0665 11.4431 15.2683 9.24133 15.2683 6.52528C15.2683 3.80922 13.0665 1.60742 10.3505 1.60742C7.63442 1.60742 5.43262 3.80922 5.43262 6.52528C5.43262 9.24133 7.63442 11.4431 10.3505 11.4431Z",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5574 9.25742C26.6698 9.25742 28.3824 7.54491 28.3824 5.43242C28.3824 3.31993 26.6698 1.60742 24.5574 1.60742C22.445 1.60742 20.7324 3.31993 20.7324 5.43242C20.7324 7.54491 22.445 9.25742 24.5574 9.25742Z",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4947 12.5931C28.8792 11.8891 28.1203 11.3248 27.2688 10.9382C26.4174 10.5516 25.4931 10.3516 24.5579 10.3516C23.6227 10.3516 22.6984 10.5516 21.847 10.9382C20.9955 11.3248 20.2366 11.8891 19.6211 12.5931",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2074 23.4648H23.4645C22.2574 23.4648 21.2788 24.4435 21.2788 25.6506V32.2077C21.2788 33.4148 22.2574 34.3934 23.4645 34.3934H32.2074C33.4145 34.3934 34.3931 33.4148 34.3931 32.2077V25.6506C34.3931 24.4435 33.4145 23.4648 32.2074 23.4648Z",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8358 16.9082C26.6765 16.9082 25.5645 17.3688 24.7447 18.1886C23.925 19.0084 23.4644 20.1203 23.4644 21.2796V23.4653H32.2072V21.2796C32.2072 20.1203 31.7466 19.0084 30.9268 18.1886C30.107 17.3688 28.9951 16.9082 27.8358 16.9082Z",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.836 29.5167C27.5342 29.5167 27.2896 29.272 27.2896 28.9703C27.2896 28.6685 27.5342 28.4238 27.836 28.4238",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8359 29.5167C28.1377 29.5167 28.3824 29.272 28.3824 28.9703C28.3824 28.6685 28.1377 28.4238 27.8359 28.4238",
    stroke: "#A9B9B9",
    strokeWidth: 2.18571
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_48434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.9714,
    height: 34.9714,
    fill: "white",
    transform: "translate(0.51416 0.513672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitedIcon);
export default __webpack_public_path__ + "static/media/limited-icon.492854b26faf19f6f18a948474a163bb.svg";
export { ForwardRef as ReactComponent };